import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { Modal } from "react-bootstrap";
import "../../styles/login.css";
import label from "../../login/labels/reset_password_en.json";
import {
  setChangePasswordFlg,
  ChangePasswordRequest,
} from "../actions/userAction";

export default function ChangePassword(props) {
  const { register, handleSubmit, formState, errors, watch, clearErrors } =
    useForm({
      mode: "onChange",
    });

  const dispatch = useDispatch();

  const showChangePwdModal = useSelector(
    (state) => state.userManagementReducer.showChangePwdModal
  );

  const confirmpassword = watch("confirm_password");
  const [confirmPasswordFlag, setConfirmPasswordFlag] = useState(false);
  const [passwordFlag, setPasswordFlag] = useState(false);
  const [currntPasswordFlag, setCurrentPasswordFlag] = useState(true);
  const modalCancel = () => {
    dispatch(setChangePasswordFlg(false));
    setConfirmPasswordFlag(false);
    setPasswordFlag(false);
    setCurrentPasswordFlag(true);
    clearErrors();
  };

  const checkValidity = (evt) => {
    if (evt.target.value === watch("password")) {
      setConfirmPasswordFlag(false);
    } else {
      setConfirmPasswordFlag(true);
    }

    if (evt.target.value === watch("confirm_password")) {
      setPasswordFlag(false);
    } else {
      setPasswordFlag(true);
    }
  };
  const checkValidityForSamepasswaord = (evt) => {
    checkValidity(evt);
    if (evt.target.value === watch("currentpassword")) {
      setCurrentPasswordFlag(false);
    } else {
      setCurrentPasswordFlag(true);
    }
  };
  const onSubmit = (data) => {
    if (!confirmPasswordFlag && currntPasswordFlag && !passwordFlag) {
      let reqBody = {
        oldPassword: data.currentpassword,
        newPassword: data.password,
      };
      dispatch(ChangePasswordRequest(reqBody, props));
    }
  };
  return (
    <form>
      <div>
        <Modal show={showChangePwdModal} onHide={modalCancel} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label className="LeftText">
                {label.OLD_PWD}
                <span className="errorText"> *</span>
              </label>

              <input
                className="form-control"
                id="registrationFormControlInput1"
                type="password"
                name="currentpassword"
                ref={register({ required: true })}
              />
              {_.get("currentpassword.type", errors) === "required" && (
                <p className="errorText">
                  {label.validationMessage.OLD_PWD_REQ}
                </p>
              )}
            </div>
            <div className="form-group">
              <label className="LeftText">
                {label.PASSWORD}
                <span className="errorText">*</span>
              </label>
              <input
                type="password"
                className="form-control"
                id="registrationFormControlInput5"
                name="password"
                ref={register({
                  required: true,
                  minLength: 8,
                  maxLength: 15,
                  validate: {
                    oneCapitalLetter: (value) =>
                      /(?![.\n])(?=.*[A-Z]).*$/.test(value),
                    oneNumber: (value) => /((?=.*\d)|(?=.*\W+)).*$/.test(value),
                    oneSpecialCharacter: (value) =>
                      /(?=.*[!@#%&])(?=.{8,}$)/.test(value),
                  },
                })}
                onChange={checkValidityForSamepasswaord}
              />
              {_.get("password.type", errors) === "required" && (
                <p className="errorText">
                  {label.validationMessage.NEW_PWD_REQ}
                </p>
              )}
              {_.get("password.type", errors) === "minLength" && (
                <p className="errorText">
                  {label.validationMessage.MIN_LENGTH_VALIDATION}
                </p>
              )}
              {_.get("password.type", errors) === "maxLength" && (
                <p className="errorText">
                  {label.validationMessage.MAX_LENGTH_VALIDATION}
                </p>
              )}
              {errors.password?.type === "oneCapitalLetter" && (
                <p className="errorText">
                  {label.validationMessage.MIN_ONE_CAPITAL_LETTER}
                </p>
              )}
              {errors.password?.type === "oneNumber" && (
                <p className="errorText">
                  {label.validationMessage.MIN_ONE_NUMBER}
                </p>
              )}
              {errors.password?.type === "oneSpecialCharacter" && (
                <p className="errorText">
                  {label.validationMessage.MIN_ONE_SPECIAL_CHAR}
                </p>
              )}
              {!currntPasswordFlag &&
              _.get("password.type", errors) !== "required" ? (
                <p className="errorText">
                  {label.validationMessage.OLD_NEW_PWD_NOT_SAME}
                </p>
              ) : (
                ""
              )}
              {passwordFlag &&
              confirmpassword &&
              _.get("password.type", errors) !== "required" ? (
                <p className="errorText">{label.validationMessage.SAME_REQ}</p>
              ) : (
                ""
              )}
            </div>
            <div className="form-group">
              <label className="LeftText">
                {label.CONFIRM_PASSWORD}
                <span className="errorText"> *</span>
              </label>

              <input
                className="form-control"
                id="registrationFormControlInput2"
                type="password"
                name="confirm_password"
                ref={register({ required: true })}
                onChange={checkValidity}
              />
              {_.get("confirm_password.type", errors) === "required" && (
                <p className="errorText">
                  {label.validationMessage.CONFIRM_PASSWORD_REQUIRED}
                </p>
              )}
              {confirmPasswordFlag &&
              _.get("confirm_password.type", errors) !== "required" ? (
                <p className="errorText">{label.validationMessage.SAME_REQ}</p>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              disabled={!formState.isValid}
              className="btn btn-primary"
              onClick={handleSubmit((e) => {
                onSubmit(e);
              })}
            >
              {label.CHANGE_PWD}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={modalCancel}
            >
              {label.CANCEL}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </form>
  );
}
